const hi = {
  // Navigation
  BACK: "वापस",
  NEXT: "आगे",

  // Actions
  SPEAK: "बोलें",
  LISTEN: "सुनें",
  RETRY: "पुनः प्रयास करें",
  SUBMIT: "जमा करें",
  START: "शुरू करें",
  SKIP: "छोड़ें",

  // Status
  LOADING: "लोड हो रहा है...",
  LOADING_GAME: "गेम लोड हो रहा है...",

  // Feedback
  HURRAY: "शाबाश!!!",
  ALMOST_THERE: "लगभग हो गया!!!",
  GREAT: "बहुत बढ़िया! आपने अच्छा किया!",
  DEMO_COMPLETE: "डेमो पूरा हुआ!",

  // Errors
  GAME_ERROR: "गेम लोड करने में त्रुटि",
  NO_OPTIONS: "कोई विकल्प उपलब्ध नहीं",
  MIC_PERMISSION:
    "हमें आपकी आवाज़ सुनने की अनुमति चाहिए! कृपया माइक्रोफ़ोन एक्सेस दें।",
  CANT_HEAR: "हम आपकी आवाज़ नहीं सुन सकते!",

  // Microphone / Audio
  MIC_TEST: "आइए अपने माइक्रोफ़ोन का परीक्षण करें!",
  LISTEN_AND_REPEAT: "नमस्ते! ऑडियो सुनें और दोहराएं!",
  ALL_TESTS_PASSED: "सभी परीक्षण पास हुए! आप सीखना शुरू करने के लिए तैयार हैं!",
  CLICK_LISTEN: "सुनने के लिए क्लिक करें",

  // Phone conversation activity
  PHONE_RINGS: "फ़ोन बज रहा है...",
  CONVO_DONE: "बातचीत पूरी हुई!",

  // Practice.jsx — activity headers
  PRACTICE_GUESS_IMAGE: "नीचे दी तस्वीर पहचानें",
  PRACTICE_SPEAK_WORD: "नीचे दिया शब्द बोलें",
  PRACTICE_SPEAK_BELOW: "नीचे दिए गए को बोलें",
  PRACTICE_READ_QUESTION_RECORD_RESPONSE:
    "प्रश्न पढ़ें और अपना उत्तर रिकॉर्ड करें",
  PRACTICE_READ_QUESTION_SELECT_ANSWER: "प्रश्न पढ़ें और सही उत्तर चुनें",
  PRACTICE_LOOK_PICTURE_SPEAK_ANSWER: "चित्र देखें और नीचे से सही उत्तर बोलें",
  PRACTICE_FORM_SENTENCE_SPEAK: "शब्दों से वाक्य बनाएं और बोलें",
  PRACTICE_FILL_IN_THE_BLANK: "खाली जगह भरें",
  PRACTICE_LETTER_RECOGNITION: "अक्षर पहचान",
  PRACTICE_MEMORY_CHALLENGE: "मेमोरी चुनौती",
  PRACTICE_F3_APPLY_LETTER_SPEED: "लागू करें {step} - अक्षर गति",
  PRACTICE_F3_PRACTICE_LETTER_SPEED: "अभ्यास {step} - अक्षर गति",
  PRACTICE_LETTER_LAUNCHER_TITLE: "लेटर लॉन्चर",
  PRACTICE_LETTER_LAUNCHER_NOT_IMPLEMENTED: "लेटर लॉन्चर अभी उपलब्ध नहीं है।",
  PRACTICE_UNABLE_LOAD_CONTENT_RETRY:
    "सामग्री लोड नहीं हो सकी। कृपया पुनः प्रयास करें।",
  PRACTICE_UNABLE_LOAD_F2_STEP_RETRY:
    "F2 चरण लोड नहीं हो सका। कृपया पुनः प्रयास करें।",
  PRACTICE_UNABLE_LOAD_F3_STEP_RETRY:
    "F3 चरण लोड नहीं हो सका। कृपया पुनः प्रयास करें।",
  PRACTICE_UNABLE_LOAD_F1_STEP_RETRY:
    "F1 चरण लोड नहीं हो सका। कृपया पुनः प्रयास करें।",
  PRACTICE_F3_LETTER_LAUNCHER_STUB_TITLE: "F3 फ़्लो - लेटर लॉन्चर",

  // Assesment.jsx — discovery screen, header, dialogs
  ASSESSMENT_TEST_LANGUAGE_SKILLS: "आइए अपनी भाषा कौशल जाँचें",
  ASSESSMENT_GOOD_LANGUAGE_SKILLS: "आपकी भाषा कौशल अच्छी है",
  ASSESSMENT_TAKE_COMPLETE_LEVEL:
    "स्तर {level} पूरा करने के लिए मूल्यांकन दें।",
  ASSESSMENT_TAKE_DISCOVER_LEVEL: "अपना स्तर जानने के लिए मूल्यांकन दें",
  ASSESSMENT_START_F1: "F1 शुरू करें",
  ASSESSMENT_START_F2: "F2 शुरू करें",
  ASSESSMENT_START_F3: "F3 शुरू करें",
  ASSESSMENT_LEARN_LETTERS: "अक्षर सीखें",
  ASSESSMENT_START_LEVEL: "स्तर {level} शुरू करें",
  ASSESSMENT_WORDS_LEARNT: "शब्द सीखे",
  ASSESSMENT_WORDS_PER_MINUTE: "शब्द प्रति मिनट",
  ASSESSMENT_SELECT_LANGUAGE: "भाषा चुनें",
  ASSESSMENT_LANGUAGE_SHORT: "भाषा",
  ASSESSMENT_AUDIO_TEST: "ऑडियो जाँच",
  ASSESSMENT_ALPHABET_CHART: "वर्णमाला चार्ट",
  ASSESSMENT_LOGOUT: "लॉग आउट",
  ASSESSMENT_GO_HOME_CHANGE_LANGUAGE: "भाषा बदलने के लिए होम स्क्रीन पर जाएँ",
  ASSESSMENT_DIALOG_OOPS: "ओह...",
  ASSESSMENT_DIALOG_CONTINUE: "जारी रखें",
  ASSESSMENT_LANG_CONFIRM: "पुष्टि करें",
};

export default hi;
